export enum ProjectSection {
  PROJECT_INFORMATION = 'Project Information*',
  PROJECT_CONFIG = 'Project Config',
  ADDITIONAL_INFORMATION = 'Additional Information',
  JOB_SITE_ADDRESS = 'Job Site Address*',
  LOCATION_SELECTION = 'Location Selection*',
  COMPANIES = 'Buyers & Other Companies',
  PRODUCT_INFO = 'Product(s) info',
  LOCATIONS_INFO = 'Location(s) info',
  DETAILS = 'Details',
  FORECASTS = 'Forecasts',
  TERMS = 'Terms/T&C',
  NOTES = 'Notes (Internal Only)',
  FILES = 'Files',
}
